export default {
    menuText: '#21212A',
    menuActiveText: '#FFFFFF',
    subMenuActiveText: '#f4f4f5',
    menuBg: '#F4F6F8',
    menuHover: '#158869',
    subMenuBg: '#158869',
    subMenuHover: '#158869',
    sideBarWidth: '210px',
}


// WEBPACK FOOTER //
// ./src/assets/js/menu-css-variables.js